module.exports = __webpack_public_path__ + "img/hr-branch-particle-02.26dc8219.png";